import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    toolbar: {
        height: theme.spacing(7)
    }
}))

export default useStyles
